import React, { FC } from 'react';
import styles from './title.module.scss';

export const EntitiesTitleText: FC = ({ children }) => (
  <span className={styles.title}>{children}</span>
);
